/**
 * Text component inspired by Park UI's design system
 */

import React from "react";
import { css } from "../../lib/panda";
import { presets } from "../../styles";

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
  as?: "p" | "span" | "div" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  variant?: "body" | "bodyLarge" | "heading1" | "heading2" | "heading3";
  children: React.ReactNode;
}

const textVariants = {
  body: presets.text.body.base,
  bodyLarge: presets.text.body.large,
  heading1: presets.text.heading.h1,
  heading2: presets.text.heading.h2,
  heading3: presets.text.heading.h3,
};

export const Text = React.forwardRef<HTMLElement, TextProps>(
  (
    {
      as: Component = "p",
      variant = "body",
      children,
      className,
      style,
      ...props
    },
    ref
  ) => {
    const textStyles = css(textVariants[variant], style);

    return (
      <Component ref={ref as any} style={textStyles} {...props}>
        {children}
      </Component>
    );
  }
);

Text.displayName = "Text";
